/**
 * joy.ts — Categoría "Joyería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_joy",
  skuPrefix: "JOY",
  categoria: "Joyería",
} as const;

export const cat_joy_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Anillo Oro 18k Solitario",
    marca: "Kevin's Joyería",
    origen: "Colombia",
    costo: 850000,
    precio: 1299000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Bóveda J1",
    proveedor: "Kevin's Joyería S.A.",
    garantia: "5 años",
    material: "Oro 18k + circonia",
    colorProducto: "Dorado",
    talla: "16",
    descripcionLarga:
      "Anillo solitario en oro amarillo 18k con piedra circonia talla brillante 0.5ct. Certificado de autenticidad.",
    especificaciones: [
      { clave: "Material", valor: "Oro 18k" },
      { clave: "Piedra", valor: "Circonia 0.5ct" },
    ],
    imageKeywords: ["gold-ring", "solitaire-ring", "engagement-ring"],
    color: "bg-amber-400",
    shape: "circle",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Cadena Oro 18k 50cm",
    marca: "Bulgari",
    origen: "Italia",
    costo: 1850000,
    precio: 2790000,
    stock: 5,
    stockMinimo: 1,
    stockMaximo: 10,
    unidad: "unidad",
    ubicacionFisica: "Bóveda J1",
    proveedor: "Bulgari Colombia",
    garantia: "10 años",
    material: "Oro 18k",
    colorProducto: "Dorado",
    dimensiones: "50cm",
    descripcionLarga:
      "Cadena fina eslabón barbada en oro 18k, 50cm de largo. Cierre mosquetón seguro. Estuche de terciopelo incluido.",
    especificaciones: [
      { clave: "Largo", valor: "50cm" },
      { clave: "Material", valor: "Oro 18k" },
    ],
    imageKeywords: ["gold-chain", "luxury-necklace", "gold-jewelry"],
    color: "bg-amber-400",
    shape: "square",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Aretes Perlas Cultivadas",
    marca: "Swarovski",
    origen: "Austria",
    costo: 185000,
    precio: 289000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "par",
    ubicacionFisica: "Vitrina J2",
    proveedor: "Swarovski Colombia",
    garantia: "2 años",
    material: "Plata 925 + perla cultivada",
    colorProducto: "Plata/blanco",
    descripcionLarga:
      "Aretes clásicos con perla cultivada 8mm montada en plata 925. Estilo atemporal para ocasiones especiales.",
    especificaciones: [
      { clave: "Material", valor: "Plata 925" },
      { clave: "Perla", valor: "Cultivada 8mm" },
    ],
    imageKeywords: ["pearl-earrings", "silver-earrings", "jewelry"],
    color: "bg-white",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Pulsera Plata 925",
    marca: "Pandora",
    modelo: "Moments",
    origen: "Dinamarca",
    costo: 225000,
    precio: 349000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "unidad",
    ubicacionFisica: "Vitrina J2",
    proveedor: "Pandora Colombia",
    garantia: "2 años",
    material: "Plata 925",
    colorProducto: "Plata",
    dimensiones: "19cm",
    descripcionLarga:
      "Pulsera Pandora Moments base en plata 925 con cierre de corazón. Personalizable con charms originales.",
    especificaciones: [
      { clave: "Material", valor: "Plata 925" },
      { clave: "Largo", valor: "19cm" },
    ],
    imageKeywords: ["silver-bracelet", "pandora-bracelet", "womens-jewelry"],
    color: "bg-slate-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Reloj Dama Luxury",
    marca: "Michael Kors",
    modelo: "Parker MK5491",
    origen: "EE.UU.",
    costo: 485000,
    precio: 749000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Vitrina J3",
    proveedor: "Michael Kors Colombia",
    garantia: "2 años",
    material: "Acero + cristales",
    colorProducto: "Dorado",
    dimensiones: "39mm",
    descripcionLarga:
      "Reloj femenino con correa de acero dorado, bisel con cristales y carátula madreperla. Cronógrafo y fecha.",
    especificaciones: [
      { clave: "Diámetro", valor: "39mm" },
      { clave: "Movimiento", valor: "Cuarzo" },
    ],
    imageKeywords: ["luxury-watch", "womens-watch", "michael-kors-watch"],
    color: "bg-amber-400",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Collar Plata Corazón",
    marca: "Tiffany & Co",
    modelo: "Return to Tiffany",
    origen: "EE.UU.",
    costo: 585000,
    precio: 899000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Bóveda J1",
    proveedor: "Tiffany & Co Colombia",
    garantia: "Vitalicia",
    material: "Plata 925",
    colorProducto: "Plata",
    descripcionLarga:
      "Icónico collar Tiffany con dije de corazón grabado. Plata esterlina, cadena 40cm. Estuche azul original.",
    especificaciones: [
      { clave: "Material", valor: "Plata 925" },
      { clave: "Largo cadena", valor: "40cm" },
    ],
    imageKeywords: ["silver-necklace", "tiffany-necklace", "heart-pendant"],
    color: "bg-cyan-200",
    shape: "square",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Dije de Corazón Oro 18k",
    marca: "Kevin's Joyería",
    origen: "Colombia",
    costo: 325000,
    precio: 499000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Vitrina J2",
    proveedor: "Kevin's Joyería S.A.",
    material: "Oro 18k",
    colorProducto: "Dorado",
    descripcionLarga:
      "Dije en forma de corazón pequeño 1.5cm en oro 18k. Ideal para compaginar con cadena (no incluida).",
    especificaciones: [
      { clave: "Material", valor: "Oro 18k" },
      { clave: "Tamaño", valor: "1.5cm" },
    ],
    imageKeywords: ["gold-pendant", "heart-pendant", "18k-gold"],
    color: "bg-amber-400",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Set Alianzas Matrimonio",
    marca: "Kevin's Joyería",
    origen: "Colombia",
    costo: 1650000,
    precio: 2490000,
    stock: 6,
    stockMinimo: 2,
    stockMaximo: 12,
    unidad: "par",
    ubicacionFisica: "Bóveda J1",
    proveedor: "Kevin's Joyería S.A.",
    garantia: "Vitalicia",
    material: "Oro 18k",
    colorProducto: "Dorado",
    descripcionLarga:
      "Par de alianzas de matrimonio en oro 18k, acabado mate-brillante. Grabado personalizable sin costo.",
    especificaciones: [
      { clave: "Material", valor: "Oro 18k" },
      { clave: "Grabado", valor: "Personalizable" },
    ],
    imageKeywords: ["wedding-rings", "gold-bands", "matrimonial-rings"],
    color: "bg-amber-400",
    shape: "circle",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Piercing Tragus Titanio",
    marca: "BodyGems",
    origen: "EE.UU.",
    costo: 35000,
    precio: 54900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Vitrina J4",
    proveedor: "BodyGems Colombia",
    material: "Titanio grado médico",
    colorProducto: "Plata",
    descripcionLarga:
      "Piercing tragus en titanio implant grado medical, con piedra circonia 3mm. Hipoalergénico.",
    especificaciones: [
      { clave: "Material", valor: "Titanio ASTM-F136" },
      { clave: "Calibre", valor: "16G" },
    ],
    imageKeywords: ["piercing", "tragus-piercing", "body-jewelry"],
    color: "bg-slate-300",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Anillo Compromiso Diamante",
    marca: "Tiffany & Co",
    modelo: "Soleste",
    origen: "EE.UU.",
    costo: 6850000,
    precio: 9990000,
    stock: 3,
    stockMinimo: 1,
    stockMaximo: 6,
    unidad: "unidad",
    ubicacionFisica: "Bóveda J1",
    proveedor: "Tiffany & Co Colombia",
    garantia: "Vitalicia",
    material: "Platino + diamante",
    colorProducto: "Plata",
    talla: "14",
    descripcionLarga:
      "Anillo de compromiso Tiffany Soleste con diamante central 0.7ct (VVS1, F color) y halo de diamantes. Certificado GIA.",
    especificaciones: [
      { clave: "Diamante central", valor: "0.7ct VVS1 F" },
      { clave: "Material", valor: "Platino 950" },
    ],
    imageKeywords: ["diamond-ring", "engagement-ring", "tiffany-ring"],
    color: "bg-slate-200",
    shape: "circle",
    gastoMargen: "ambicioso",
  }),
];
